module.exports = __webpack_public_path__ + "static/media/item_22_6_comp.cd1f1a77.png";